import config from 'config';

import {
  useMarketingDisposition,
  useReferrerOptions,
} from '~/techstyle-shared/react-marketing';

import { useBuilderReferrerOptions } from './useBuilderReferrerOptions';

const scrubsCustomerReferralList = config.get('public.HDYH.scrubs');

export default function useHdyhOptions() {
  const { experience } = useMarketingDisposition();
  const { options } = useBuilderReferrerOptions();

  const customerReferrerList =
    experience === 'scrubs' ? scrubsCustomerReferralList : options;

  return useReferrerOptions({ customerReferrerList });
}
